<!-- 收货明细 -->
<template>
  <div class="page-content">
    <c-header pageName="撤单明细"></c-header>

    <div class="tool-content flex-wrap">
      <div class="order-header flex">
        <section>撤单编号 : {{ sn }}</section>
      </div>
      <div class="search-tool flex" >
        <van-search
          v-model="barCode"
          placeholder="请输入国际条码"
          show-action
          :autofocus="true"
          @search="onSearch"
        >
          <div slot="action" @click="onSearch">扫描国际条码</div>
        </van-search>
      </div>
    </div>
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      :offset="100"
    >
      <div class="goods-item flex-wrap" v-for="(item,index) in orderList" :key="index">
        <section>商品名称 : {{ item.stockInfo.productName }}</section>
        <section>国际编码 : {{ item.stockInfo.barCode }}</section>
        <section>数量 : {{ item.qty }}</section>
        <section>商品状态 :&nbsp;
          <span :style="item.defectFlag ? 'color: #F56C6C' : 'color: #67C23A'">
            {{ item.defectFlag ? "不良品" : "良品" }}
          </span>
        </section>
        <section>库位 : {{ item.stockInfo.slCode }}</section>
      </div>
    </van-list>
    <c-editDialog :show="editDialogShow" @closeDialog="closeEditDialog" :info="editInfoDetail"
                  :saveDetailInfoType="saveDetailInfoType"></c-editDialog>
    <c-goodsDetail :show="detailDialogShow" @closeDialog="closeDetailDialog" :info="editInfoDetail"></c-goodsDetail>
  </div>
</template>

<script>
import Header from "../components/headerNav.vue";
import EditDialog from "../components/receivingDetailEditDialog.vue";
import GoodsDetailDialog from "../components/receivingGoodsDetailDialog.vue";
import Utils from "../util/utils";
import DataFormat from "../util/dataFormat";

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 5,
      loading: false,
      finished: true,
      orderId: "",
      sn: "",
      barCode: "",
      selectNav: 0, // 0-未收货，1-已收货
      saveDetailInfoType: 0, // 明细保存方式（0--新增，1--更新）
      orderList: [],
      searchOrder: [],
      editDialogShow: false, // 显示编辑弹框
      detailDialogShow: false, // 显示详情弹窗
      editInfoDetail: {}, // 选择进行维护的数据
      inboundApply: {}, // 入库申请单信息
    };
  },
  components: {
    "c-header": Header,
    "c-editDialog": EditDialog,
    "c-goodsDetail": GoodsDetailDialog,
  },
  mounted() {
    this.orderId = this.$route.query.orderId;
    this.sn = this.$route.query.sn;
    this.getOrderCancelDetails();
  },
  methods: {

    onSearch() {

    },

    // 撤单明细
    getOrderCancelDetails() {
      this.$post(this.URL.findOrderCancelDetailByOrderId, {id: this.orderId}).then(res => {
        if (res.success && res.data) {
          this.orderList = res.data;
        }
      });
    },

    // 显示详情弹框
    onShowDetailDialog(data) {
      this.detailDialogShow = true;
      this.editInfoDetail = data;
    },
    // 关闭编辑弹框
    closeEditDialog() {
      this.editDialogShow = false;
    },
    closeDetailDialog() {
      this.detailDialogShow = false;
    },

    //收货确认
    handleShelvesConfirm(param) {
      this.$post(this.URL.receiptConfirm, param).then(res => {
        if (res.success) {
          this.$toast.success("收货成功");
          this.$router.push("/receiving");
        } else {
          this.$toast.fail(res.message);
        }
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.nav-tool {
  width: 100%;
  justify-content: center;
  padding: 0 3rem;
  height: 3rem;
  align-items: center;
  background-color: #dc6350;

  section {
    display: inline-flex;
    width: 7rem;
    justify-content: center;
    border: 1px solid #fff;
    height: 1.8rem;
    align-items: center;
    font-size: 0.9rem;
    color: white;
  }

  .activity {
    background-color: white;
    color: #dc6350;
  }
}

.tool-content {
  font-size: 0.8rem;
  color: #444;
  padding: 0.5rem 0.5rem 0 0.5rem;

  .order-header {
    height: 3rem;
    align-items: center;
    font-size: 0.9rem;
  }

  .button-tool {
    height: 2.5rem;
    align-items: center;
    padding-bottom: 0.5rem;
    border-bottom: 0.2rem solid #f0f0f0;

    label {
      display: inline-flex;
      margin-right: 0.5rem;
      height: 1.8rem;
      align-items: center;
      padding: 0 0.8rem;
      background-color: #dc6350;
      border-radius: 0.2rem;
      color: white;
    }
  }

  .search-tool {
    height: 2.5rem;
    align-items: center;
    border-radius: 0.3rem;
    border: 1px solid #f0f0f0;

    .van-search {
      width: 100%;
      padding: 0;
      //box-shadow: 1px 2px 1px #f0f0f0;
      .van-search__action {
        background-color: white;
      }
    }
  }
}

.search-result {
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  color: #444;
  margin-top: 0.5rem;
  background-color: #fafafa;
  border-radius: 0.3rem;
  margin: 0.5rem;

  .order-left {
    display: inline-flex;
    width: 80%;
    flex-wrap: wrap;

    section {
      display: flex;
      width: 100%;
      padding: 0.2rem 0;
    }
  }

  .order-right {
    display: inline-flex;
    width: 20%;
    align-items: center;
    justify-content: center;

    section {
      display: inline-flex;
      background-color: #dc6350;
      color: white;
      padding: 0.3rem 0.5rem;
      border-radius: 0.2rem;
    }
  }
}

.receiving-button {
  justify-content: center;
  padding-top: 1rem;
  font-size: 0.85rem;

  label {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    width: 16rem;
    height: 2.2rem;
    background-color: #dc6350;
    color: white;
    border-radius: 0.2rem;
  }
}

.van-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  padding: 1rem 0.5rem;
  font-size: 0.85rem;
  padding: 0.5rem 0.8rem;
  color: #444;

  .goods-item {
    border-bottom: 1px solid #f0f0f0;
    padding: 0.5rem 0;

    section {
      display: flex;
      width: 100%;
      line-height: 1.2rem;
    }

    .button-tool {
      height: 2.5rem;
      align-items: center;

      label {
        display: inline-flex;
        margin-right: 0.5rem;
        height: 1.8rem;
        align-items: center;
        padding: 0 0.8rem;
        background-color: #dc6350;
        border-radius: 0.2rem;
        color: white;
      }
    }
  }

  >>> .van-list__loading {
    display: flex;
    width: 100%;
    justify-content: center;
  }

  >>> .van-list__finished-text {
    display: flex;
    width: 100%;
    justify-content: center;
  }

}

.van-field__control {
  background-color: white;
}

.van-search .van-cell {
  background-color: white;
}

.van-search__content {
  background-color: white;
}

.van-search__action {
  border-left: 1px solid #f0f0f0;
}
</style>



// WEBPACK FOOTER //
// src/pages/OrderCancelDetail.vue